// eslint-disable-next-line import/no-anonymous-default-export

export default {
  header: {
    self: {},
    items: [],
  },
  aside: {
    self: {},
    items: [
      { section: "دسترسی سریع" },
      {
        title: "Dashboard",
        root: true,
        icon: "flaticon2-architecture-and-city",
        page: "dashboard",
        translate: "MENU.DASHBOARD",
        bullet: "dot",
      },
      {
        title: "Support",
        root: true,
        icon: "flaticon-speech-bubble-1",
        page: "support",
        translate: "MENU.SUPPORT",
        bullet: "dot",
        // badge:{value:getSupportCount(),type:"kt-badge--danger"}
      },
      {
        title: "Report",
        root: true,
        icon: "flaticon2-line-chart",
        page: "Report",
        translate: "MENU.REPORT",
        bullet: "dot",
      },
      { section: "مدیریت" },
      {
        title: "manage places",
        root: true,
        icon: "flaticon-map-location",
        translate: "MENU.MANAGE_PLACES",
        page: "places",
      },
      {
        title: "manage users",
        root: true,
        icon: "flaticon-users",
        translate: "MENU.MANAGE_USERS",
        page: "users",
      },
      {
        title: "manage caterings",
        root: true,
        icon: "flaticon-truck",
        translate: "MENU.MANAGE_CATERING",
        page: "catering",
      },
      {
        title: "manage coaches",
        root: true,
        icon: "flaticon-profile-1",
        translate: "MENU.MANAGE_COACH",
        page: "coach",
      },
      {
        title: "manage corporates",
        root: true,
        icon: "flaticon-tool",
        translate: "MENU.MANAGE_CORPORATES",
        page: "corporates",
      },
      {
        title: "manage affiliate",
        root: true,
        icon: "flaticon-users",
        translate: "MENU.MANAGE_AFFILIATE",
        page: "affiliate",
      },
      { section: "مالی" },
      {
        title: "manage process",
        root: true,
        icon: "flaticon2-document",
        translate: "MENU.MANAGE_PROCESS",
        page: "process",
      },
      {
        title: "manage invoices",
        root: true,
        icon: "flaticon2-document",
        translate: "MENU.MANAGE_INVOICES",
        page: "invoices",
      },
      {
        title: "manage subscribes",
        root: true,
        icon: "flaticon-book",
        translate: "MENU.MANAGE_SELLS",
        page: "sells",
      },
      {
        title: "manage gifts",
        root: true,
        icon: "flaticon2-gift",
        translate: "MENU.MANAGE_GIFTS",
        page: "Gifts",
      },
      // {
      //   title: "manage transactions",
      //   root: true,
      //   icon: "flaticon2-document",
      //   translate: "MENU.MANAGE_TRANSACTIONS",
      //   page: "FinanceTransactions",
      // },
      { section: "محتوا" },
      {
        title: "manage HomePage",
        root: true,
        icon: "flaticon-home",
        translate: "MENU.MANAGE_HOMEPAGE",
        page: "homePage",
      },
      {
        title: "manage articles",
        root: true,
        icon: "flaticon-book",
        translate: "MENU.MANAGE_ARTICLES",
        page: "articles",
      },
      {
        title: "manage links",
        root: true,
        icon: "flaticon-more-v4",
        translate: "MENU.MANAGE_LINKS",
        page: "links",
      },
      { section: "مدیا" },
      {
        title: "manage media",
        root: true,
        icon: "flaticon-folder-1",
        translate: "MENU.MANAGE_MEDIA",
        page: "media",
      },
      { section: "تنظیمات" },
      {
        title: "settings",
        root: true,
        icon: "flaticon-settings-1",
        translate: "MENU.SETTINGS",
        page: "settings",
      },
    ],
  },
};
